// This file is generated automatically by scripts/build-env.js
// Do not edit this file manually - your changes will be overwritten

export const environment = {
  production: false,
  local: false,
  API_URL: 'https://staging.api.tools.adverio.io/api',
  CLIENT_SECRET: '3Pjc6XLWOPE0eWapOg07NwLQmeL3Dblpe79cTJo76HAVggPunjdDznNqfKkADbu42y1P2wLGY7SDlAygu5fpyILiT3QDa1lXxL51IQEwcpBIFhEo8areRPFcwrSZIuEv',
  CLIENT_ID: 'ePlCXzz59rA26van96o2ovjm14aZY9lnUe2R3S5S',
  highcharts_animations: true, // Disable for performance in prod
  highcharts_navigator: true,

  monitoring: {
    seo_scraper: {
      enabled: true,
      polling_interval: 60000, // Longer intervals in prod/staging
      max_retry_attempts: 5,
    },
    audit_automation: {
      enabled: true,
      polling_interval: 60000,
      auto_refresh: false, // Manual refresh in prod/staging
    },
    forecasting_monitor: {
      enabled: true,
      polling_interval: 60000,
      auto_refresh: false, // Manual refresh in prod/staging
    },
    alerts: {
      enabled: true,
      test_mode: true, // Test mode enabled in staging for testing
    },
    image_analyzer: {
      enabled: true,
    },
  },

  features: {
    seo_scraper_monitor: true,
    forecasting_monitor: true,
    real_time_updates: true,
    alert_configuration: true,
    audit_automation: true,
    image_analyzer: true,
  },
};
